import $axios from "../api/accessor";
import { $api } from "../api/api";
import {
  OrderProductsResponse,
  ProductOrdersFilterParams,
} from "../interfaces/admin.interface";

export const OrdersService = {
  async getOrderProducts(orderId: number | string) {
    if (!orderId) {
      return {
        data: null,
        status: 400,
      };
    }

    try {
      const response = await $axios.get<OrderProductsResponse>(
        $api("order_products", { order_id: orderId })
      );
      return {
        data: response?.data,
        status: response?.status,
      };
    } catch (error: any) {
      return {
        data: error?.response?.data || null,
        status: error?.response?.status || 500,
        error,
      };
    }
  },
  async getProductOrders(params?: ProductOrdersFilterParams) {
    const cleanParams: Record<string, any> = {};
    if (params) {
      Object.entries(params).forEach(([key, value]) => {
        if (value === undefined || value === null || value === "") return;
        cleanParams[key] = value;
      });
    }

    try {
      const response = await $axios.get($api("product_orders", cleanParams));
      return {
        data: response?.data,
        status: response?.status,
      };
    } catch (error: any) {
      return {
        data: error?.response?.data || null,
        status: error?.response?.status || 500,
        error,
      };
    }
  },
  async getServiceOrders() {
    let response = await $axios.get($api("service_orders")).catch((err) => {
      return err.response;
    });
    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },

  async getInstallOrders() {
    let response = await $axios.get($api("install_orders")).catch((err) => {
      return err.response;
    });
    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },
  async getAccessoryOrders() {
    let response = await $axios.get($api("accessory_orders")).catch((err) => {
      return err.response;
    });
    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },
  async changeProductsOrderStatus(orderId: number, statusId: number) {
    try {
      const response = await $axios.get(
        $api("change_status_products", { orderId, statusId })
      );
      return {
        data: response.data,
        status: response.status,
      };
    } catch (error) {
      throw error;
    }
  },
  async changeServiceOrderStatus(orderId: number, statusId: number) {
    try {
      const response = await $axios.get(
        $api("change_status_service", { orderId, statusId })
      );
      return {
        data: response.data,
        status: response.status,
      };
    } catch (error) {
      throw error;
    }
  },
  async changeAccessoryOrderStatus(orderId: number, statusId: number) {
    try {
      const response = await $axios.get(
        $api("change_status_accessory", { orderId, statusId })
      );
      return {
        data: response.data,
        status: response.status,
      };
    } catch (error) {
      throw error;
    }
  },
};
